import signout from './signout.gql'
import createQuarterEndWindow from './create-quarter-end-window.gql'
import updateQuarterEndWindow from './update-quarter-end-window.gql'

export const SIGN_OUT = signout
export const CREATE_QUARTER_END_WINDOW = createQuarterEndWindow
export const UPDATE_QUARTER_END_WINDOW = updateQuarterEndWindow
